<template>
    <div class="cargo_content" :class="cargoContentClass">
        <b-btn v-b-toggle="id" class="cargo_toggle">
            <div class="row">
                <div class="col-6 col-lg-auto">
                    <div class="row">
                        <div class="col-sm-auto">
                            <h4>訂單日期</h4>
                        </div>
                        <div class="col-sm-auto">
                            <p>{{ contents.OrderDate }}</p>
                        </div>
                    </div>
                </div>
                <div class="col-6 col-lg-auto">
                    <div class="row">
                        <div class="col-sm-auto">
                            <h4>訂單編號</h4>
                        </div>
                        <div class="col-sm-auto">
                            <p>{{ orderId }}</p>
                        </div>
                    </div>
                </div>
                <div class="col-6 col-lg-auto">
                    <div class="row">
                        <div class="col-sm-auto">
                            <h4>付款方式</h4>
                        </div>
                        <div class="col-sm-auto">
                            <p>
                                {{ contents.PayTypeString }}
                                <span :class="payStatusClass">
                                    {{ contents.PayStatusString }}
                                </span>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-6 col-lg-auto">
                    <div class="row">
                        <div class="col-sm-auto">
                            <h4>總金額</h4>
                        </div>
                        <div class="col-sm-auto">
                            <p>{{ contents.TotalAmount }}</p>
                        </div>
                    </div>
                </div>
                <div class="col-6 col-lg-auto">
                    <div class="row">
                        <div class="col-sm-auto">
                            <h4>付款帳號</h4>
                        </div>
                        <div class="col-sm-auto">
                            <p>{{ contents.AtmAccount }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </b-btn>
        <b-collapse @show="collapseShow" :id="id" class="cargo_target">
            <b-card>
                <cargo-list v-for="(list, index) in orderDetails" v-bind:key="index" :cargoList="list" :type="type" />
            </b-card>
        </b-collapse>
    </div>
</template>

<script>
    import CargoList from '@/components/cargo/CargoList'
    import orderApi from '@/api/order'
    import _ from 'lodash'

    export default {
        components: {
            CargoList
        },
        props: {
            index: {
                type: Number,
                required: true,
            },
            contents: {
                type: Object,
                required: true,
            },
            type: {
                type: [String, Number],
                default() {
                    return 1 ; // 1 == 訂單查詢、 2 == 取消訂單
                },
            }
        },
        data() {
            return {
                orderDetails: [],
            };
        },
        computed: {
            id() {
                return `collapse3-${this.index}-${this.type}`;
            },
            payStatusClass() {
                if (this.contents.PayStatus) {
                    return 'havepay';
                }

                return '';
            },
            cargoContentClass() {
                if (this.contents.PayStatus) {
                    return '';
                }

                return 'cargo_content_dark';
            },
            orderId() {
                return _.get(this.contents, 'OrderID');
            },
        },
        methods: {
            collapseShow() {
                if (!this.orderDetails.length) {
                    this.getQueryOrderDetail();
                }
            },
            getQueryOrderDetail() {
                orderApi.queryOrderDetail({ OrderID: this.orderId, type: this.type }, (data) => {
                    this.orderDetails = data ? data : [];
                });
            },
        },
    }
</script>
